import React from 'react';

import { useQuery } from 'react-apollo';
import { Menu } from 'semantic-ui-react';
import { Switch, Route, Link } from 'react-router-dom';

import { QUERIES_MENU_ITEMS_QUERY, MUTATIONS_MENU_ITEMS_QUERY, TYPES_QUERY } from '../../graphql/introspectionQuery';

import ContentGrid from '../../components/ContentGrid';
import ReferenceContainer from './ReferenceContainer';
import ReferenceObjectContainer from './ReferenceObjectContainer'

const createMenuItems = (array, route) => {
  return array.sort().map((name, index) => (
    <Menu.Menu key={index}>
      <Menu.Item>
        <Link
          to={`/reference/${route}/${name}`}
          onClick={() => {
            window.scrollTo(0, 0)
          }}
        >
          {name}
        </Link>
      </Menu.Item>
    </Menu.Menu>
  ));
}

const Reference = () => {
  const pathname = window.location.pathname.split('/')[2]
  const { loading: queriesLoading, data: queriesData } = useQuery(QUERIES_MENU_ITEMS_QUERY);
  const { loading: mutationsLoading, data: mutationsData } = useQuery(MUTATIONS_MENU_ITEMS_QUERY);
  const { loading: typesLoading, data: typesData } = useQuery(TYPES_QUERY);

  if (queriesLoading || mutationsLoading || typesLoading) return <ContentGrid loading />

  const queries = queriesData.__type.fields.map(item => item.name)
  const mutations = mutationsData.__type.fields.map(item => item.name)
  const types = typesData.__schema.types.map(item => item.name)

  let menu = [];

  if (queries) {
    menu.push({
      content: 'Queries',
      items: createMenuItems(queries, 'queries')
    });
  }

  if (mutations) {
    menu.push({
      content: 'Mutations',
      items: createMenuItems(mutations, 'mutations')
    });
  }

  if (types) {
    menu.push({
      content: 'Objects',
      items: createMenuItems(types, 'types')
    });
  }

  const content = (
    <Switch>
      <Route path={`/reference/${pathname}/:name`} component={ReferenceObjectContainer} />
      <Route exact path={'/reference'} component={ReferenceContainer} />
    </Switch>
  );

  return (
    <ContentGrid accordion menu={menu} content={content} />
  );
}

export default Reference